import { useQuery } from '@tanstack/react-query'
import { PbReturnProcessConditions } from '@itsrever/rever-api'
import { getReturnConditions } from '@/api/settings-api'
import { useEcommerceId } from '@/hooks/use-ecommerce-id'

const RETURN_CONDITIONS_KEY = ['returnConditions']

export const returnConditionsKey = (ecommerceId?: string) => [
  ...RETURN_CONDITIONS_KEY,
  ecommerceId
]

// One settings-api resource holds the conditions and the non-returnable lists: one query for both.
export function useStoredReturnConditions<T>(
  select: (stored: PbReturnProcessConditions) => T
) {
  const ecommerceId = useEcommerceId()
  const query = useQuery({
    queryKey: returnConditionsKey(ecommerceId),
    queryFn: () => getReturnConditions(ecommerceId ?? ''),
    enabled: !!ecommerceId,
    select
  })
  return {
    ecommerceId,
    stored: query.data,
    loading: query.isLoading,
    loadFailed: query.isError && !query.data,
    reload: query.refetch
  }
}
